import { useSearchParams } from 'react-router-dom';

/**
 * URL-Parameter der Admin-Listen (Suche, Filter, Sortierung, Seite).
 *
 * Die URL ist die einzige Wahrheit: Ansichten sind teilbar, überleben Reload
 * und Zurück-Button, und der react-query-Key hängt direkt daran. Jede
 * Filter-/Sortieränderung springt zurück auf Seite 1 — sonst landet man auf
 * einer Seite 7, die es im neuen Ergebnis nicht mehr gibt.
 */
export const useAdminListParams = ({
  defaultSort = '',
  defaultLimit = 25,
} = {}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const parsedPage = parseInt(searchParams.get('page'), 10);
  const parsedLimit = parseInt(searchParams.get('limit'), 10);

  const setParams = (updates, { resetPage = true } = {}) => {
    const next = new URLSearchParams(searchParams);

    Object.entries(updates).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) {
        next.delete(key);
      } else {
        next.set(key, String(value));
      }
    });

    if (resetPage && !('page' in updates)) next.set('page', '1');
    // Seite 1 ist der Default und gehört nicht in die URL.
    if (next.get('page') === '1') next.delete('page');

    setSearchParams(next);
  };

  return {
    searchParams,
    page: Number.isInteger(parsedPage) && parsedPage > 0 ? parsedPage : 1,
    limit:
      Number.isInteger(parsedLimit) && parsedLimit > 0
        ? parsedLimit
        : defaultLimit,
    search: searchParams.get('search') || '',
    sort: searchParams.get('sort') || defaultSort,
    getParam: (key) => searchParams.get(key) || '',
    setParams,
    setPage: (value) => setParams({ page: value }, { resetPage: false }),
    reset: () => setSearchParams(new URLSearchParams()),
  };
};

export default useAdminListParams;
